/**
 * Calculates the principal amount based on quantity and price
 * @param Object containing quantity and price (as percentage)
 * @returns The calculated principal amount
 */
export function getPrincipal({
  quantity,
  price,
}: {
  quantity: number
  price: number
}): number {
  // Price is expressed as percentage (e.g. 98.5 for 98.5%)
  // Convert price to decimal and multiply by quantity
  return (price / 100) * quantity
}

/**
 * Calculates the accrued interest based on quantity and par value
 * @param Object containing accrued amount, quantity, and par value
 * @returns The calculated accrued interest rounded to 2 decimal places
 */
export function getAccruedInterest({
  accrued,
  quantity,
  parValue,
}: {
  accrued: number | null
  quantity: number
  parValue: number
}): number {
  if (!accrued) {
    return 0
  }
  const multiplier = quantity / parValue
  return parseFloat((accrued * multiplier).toFixed(2))
}

export function calculatePercentage(
  value?: number,
  total?: number,
  shouldRound: boolean = true,
) {
  if (!value || !total) return 0
  const result = (value / total) * 100
  if (shouldRound) {
    return Number(result.toFixed(2))
  }
  return result
}
